import { render, staticRenderFns } from "./SeletorDeImposto.vue?vue&type=template&id=2759171e&"
import script from "./SeletorDeImposto.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeImposto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
